import { useState } from "react";
import { fmtTime, type LogEvent } from "../api";

function levelClass(level: string | null): string {
  if (!level) return "";
  if (level === "ERROR" || level === "FATAL" || level === "CRITICAL") return "lvl-error";
  if (level === "WARN") return "lvl-warn";
  return "";
}

export function EventRow({ event, stream }: { event: LogEvent; stream?: string }) {
  const [open, setOpen] = useState(false);
  const hasFields = event.fields && Object.keys(event.fields).length > 0;
  return (
    <li className={`event ${levelClass(event.level)}`}>
      <button
        type="button"
        className="event-line"
        aria-expanded={hasFields ? open : undefined}
        onClick={() => hasFields && setOpen((o) => !o)}
      >
        <time dateTime={new Date(event.timestamp).toISOString()}>{fmtTime(event.timestamp)}</time>
        <span className="lvl">{event.level ?? ""}</span>
        {(stream ?? event.log_stream) && <span className="stream">{stream ?? event.log_stream}</span>}
        <span className="msg">{event.message}</span>
      </button>
      {open && hasFields && <pre className="fields">{JSON.stringify(event.fields, null, 2)}</pre>}
    </li>
  );
}

export function EventList({ events, label }: { events: LogEvent[]; label: string }) {
  if (!events.length) return <p className="muted">No events.</p>;
  return (
    <ul className="events" aria-label={label}>
      {events.map((e) => (
        <EventRow key={`${e.log_stream ?? ""}:${e.event_id}`} event={e} />
      ))}
    </ul>
  );
}
